export default {
  DOWNLOAD_START: 'Download in corso... Attendere, prego…',
  DOWNLOAD_SUCCESS: 'Grazie! Ora puoi chiudere questa finestra.'
}
